import PropTypes from 'prop-types';
import React from 'react';

import BackButton from '@/components/BackButton';
import Breadcrumbs, { Breadcrumb } from '@/components/Breadcrumbs';
import LazyEditForm from '@/components/LazyEditForm';
import Page from '@/components/Page';
import PageContent from '@/components/PageContent';
import PageHeader from '@/components/PageHeader';
import PageTitle from '@/components/PageTitle';
import PaperSheet from '@/components/PaperSheet';
import ProductNameLazy from '@/containers/ProductNameLazy';
import { ROUTE_PATH as PRODUCTS_PATH } from '@/features/productsPage/consts';

import Form from './Form';

const PageEditProduct = ({
  fetchItem,
  getItemLoadingError,
  isItemLoaded,
  isItemLoading,
  productId,
  updateProduct,
}) => (
  <Page>
    <PageHeader gutterBottom={false} xl={8}>
      <Breadcrumbs>
        <Breadcrumb to={PRODUCTS_PATH}>Товар</Breadcrumb>
        <Breadcrumb>
          <ProductNameLazy productId={productId} />
        </Breadcrumb>
      </Breadcrumbs>
      <BackButton />
      <PageTitle>Редактирование Товара</PageTitle>
    </PageHeader>
    <PageContent xl={8}>
      <PaperSheet>
        <LazyEditForm
          fetchItem={fetchItem}
          getItemLoadingError={getItemLoadingError}
          isItemLoaded={isItemLoaded}
          isItemLoading={isItemLoading}
          itemId={productId}
        >
          <Form productId={productId} onSubmit={updateProduct} />
        </LazyEditForm>
      </PaperSheet>
    </PageContent>
  </Page>
);

PageEditProduct.propTypes = {
  fetchItem: PropTypes.func.isRequired,
  getItemLoadingError: PropTypes.func.isRequired,
  isItemLoaded: PropTypes.func.isRequired,
  isItemLoading: PropTypes.func.isRequired,
  updateProduct: PropTypes.func.isRequired,
  productId: PropTypes.any.isRequired,
};

export default PageEditProduct;
